import React from 'react';
import { Create, TextInput, BooleanInput, NumberInput, DisabledInput, FormTab, TextField } from 'react-admin';

import { ReferenceField } from '../customFields';
import { TabbedForm } from '../customViews';
import OutputCenterTitle from './OutputCenterTitle';

const OutputCenterCreate = (props) => (
	<Create title={<OutputCenterTitle />} {...props}>
		<TabbedForm>
			<FormTab label="Details">
				<ReferenceField source="shopId" reference="shop">
					<TextField source="name" />
				</ReferenceField>
				<TextInput source="name" />
				<NumberInput source="index" />
				<BooleanInput source="isCheckout" />
				<BooleanInput source="isGo" />
				<BooleanInput source="active" />
				<DisabledInput source="createdAt" />
				<DisabledInput source="updatedAt" />
				<DisabledInput source="createdBy" />
				<DisabledInput source="updatedBy" />
			</FormTab>
		</TabbedForm>
	</Create>
);

export default OutputCenterCreate;
